import { ElementBase as c } from "@smartdesign/element-base";
import l, { generator as d } from "@smartdesign/list-item";
const h = `<style>
	:host {
		background-color: var(--sd-list-base-background-color, white);
	}

	.container {
		width: 100%;
		height: 100%;
	}

	:host(:focus) {
		outline: none;
	}

	:host(:focus-visible) ::slotted([focused]) {
		box-shadow: 0 0 0 1px #1467ba inset;
	}

	.container ::slotted(*) {
		display: block;
		box-sizing: border-box;
	}

	.container ::slotted(:not(:last-of-type)) {
		border-bottom: 1px solid #d9d9d9;
	}
</style>

<div class="container">
	<slot name="items"></slot>
	<slot id="default-slot"></slot>
</div>
`;
let a = 0;
const i = class i extends c {
  constructor() {
    super(), this._items = [], this._selectedIndexes = [], this._itemGenerator = d, this.onDefaultSlotChange = () => {
      let t = 0;
      this.defaultSlot.assignedElements().forEach((e) => {
        this.isSeparator(e) || this.initListItem(e, t++);
      }), this.updateFocusedElement();
    }, this.handleKeyDown = (t) => {
      let e = !0;
      switch (t.key) {
        case "ArrowDown":
        case "Down":
          this.focusIndex = Math.min(this.getListItems.length - 1, this.focusIndex + 1);
          break;
        case "ArrowUp":
        case "Up":
          this.focusIndex = Math.max(0, this.focusIndex - 1);
          break;
        case "Enter":
        case "Space":
        case " ":
          this.handleSelection(this.focusIndex, t.metaKey || t.ctrlKey);
          break;
        case "End":
        case "PageDown":
          this.focusIndex = this.items.length - 1;
          break;
        case "Home":
        case "PageUp":
          this.focusIndex = 0;
          break;
        default:
          e = !1;
          break;
      }
      e && (t.preventDefault(), t.stopPropagation());
    }, this._fallbackId = i.ID + "_" + a++, this.addEventListener("pointerup", (t) => {
      this.focusIndex = this.getListItems.indexOf(t.target), this.updateFocusedElement();
    }), this.addEventListener("focus", () => {
      this.matches(":focus-visible") && (this.focusIndex == -1 ? (this.selectedIndexes && (this.focusIndex = this.selectedIndexes[0]), this.focusIndex == -1 && this.childElementCount > 0 && (this.focusIndex = 0)) : this.updateFocusedElement());
    }), this.addEventListener("blur", () => this.removeFocusedItemAttributes());
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get items() {
    return this._items;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set items(t) {
    this._items = t, this.render();
  }
  get itemGenerator() {
    return this._itemGenerator;
  }
  set itemGenerator(t) {
    this._itemGenerator = t, this.render();
  }
  get selectionType() {
    return this.getAttribute("selection-type");
  }
  set selectionType(t) {
    t ? this.setAttribute("selection-type", t) : this.removeAttribute("selection-type");
  }
  get focusIndex() {
    return this.hasAttribute("focus-index") ? Number(this.getAttribute("focus-index")) : -1;
  }
  set focusIndex(t) {
    0 <= t && t < this.getListItems.length ? this.setAttribute("focus-index", t.toString()) : this.removeAttribute("focus-index");
  }
  get focusTarget() {
    return this.hasAttribute("focus-target");
  }
  set focusTarget(t) {
    this.toggleAttribute("focus-target", t);
  }
  getListItem(t) {
    return this.shadowRoot ? this.getListItems[t] : null;
  }
  get getListItems() {
    return Array.prototype.slice.call(this.children).filter((t) => !this.isSeparator(t));
  }
  get selectedIndexes() {
    return this._selectedIndexes;
  }
  set selectedIndexes(t) {
    const e = this._selectedIndexes || [];
    this._selectedIndexes = t || [], e.filter((s) => !this._selectedIndexes.includes(s)).forEach((s) => {
      this.setSelectedAttr(this.getListItem(s), !1);
    }), this._selectedIndexes.filter((s) => !e.includes(s)).forEach((s) => {
      this.setSelectedAttr(this.getListItem(s), !0);
    });
  }
  static get observedAttributes() {
    return ["focus-index", "focus-target"];
  }
  is() {
    return i.ID;
  }
  template() {
    const t = document.createElement("template");
    return t.innerHTML = h, t;
  }
  removeFocusedItemAttributes() {
    if (this.focusIndex != -1) {
      const t = this.getListItem(this.focusIndex);
      t && (t.removeAttribute("focused"), this.removeAttribute("aria-activedescendant"));
    }
  }
  connectedCallback() {
    super.connectedCallback(), this.defaultSlot.addEventListener("slotchange", this.onDefaultSlotChange), this.hasAttribute("role") || this.setAttribute("role", "listbox"), this.id || (this.id = this._fallbackId), this.render(), this.addEventListener("keydown", this.handleKeyDown), this.selectionType || (this.selectionType = "trigger-only");
  }
  get defaultSlot() {
    return this.shadowRoot.querySelector("#default-slot");
  }
  isSeparator(t) {
    return t.tagName == "HR" || t.getAttribute("role") == "separator";
  }
  attributeChangedCallback(t, e, s) {
    if (t === "focus-index") {
      const n = this.getListItem(e);
      n && n.removeAttribute("focused"), this.updateFocusedElement();
    } else
      t === "focus-target" && (this.focusTarget ? this.updateFocusedElement() : document.activeElement != this && this.removeFocusedItemAttributes());
  }
  render() {
    if (!this.isConnected || !this.items)
      return;
    this.querySelectorAll("[slot='items']").forEach((s) => {
      this.removeChild(s);
    });
    const t = document.createDocumentFragment();
    let e = 0;
    this.items.forEach((s, n) => {
      const o = this.itemGenerator(s, n);
      this.isSeparator(o) || this.initListItem(o, e++), o.slot = "items", t.appendChild(o);
    }), this.appendChild(t), this.updateFocusedElement();
  }
  initListItem(t, e) {
    this.setSelectedAttr(t, this.selectedIndexes.includes(e)), t.addEventListener("click", (s) => {
      this.handleItemClick(s, e);
    }), t.addEventListener("mousedown", (s) => {
      s.button == 1 && s.preventDefault();
    }), t.addEventListener("auxclick", (s) => {
      this.handleItemClick(s, e);
    }), (!t.id || t.id.startsWith(this.id + "_item_")) && (t.id = this.id + "_item_" + e);
  }
  ensureItemVisible(t) {
    const e = t.getBoundingClientRect(), s = this.getBoundingClientRect();
    e.bottom > s.bottom ? this.scrollTop += e.bottom - s.bottom : e.top < s.top && (this.scrollTop -= s.top - e.top);
  }
  updateFocusedElement() {
    const t = this.getListItem(this.focusIndex);
    t && (this.focusTarget || document.activeElement == this) ? (t.setAttribute("focused", ""), this.setAttribute("aria-activedescendant", t.id), this.ensureItemVisible(t)) : this.removeAttribute("aria-activedescendant");
  }
  handleItemClick(t, e) {
    if (t.button !== null) {
      const s = t.type == "auxclick" && t.button == 1 || t.metaKey || t.ctrlKey;
      (t.button == 0 || t.button == 1) && this.handleSelection(e, s);
    }
  }
  handleSelection(t, e) {
    const s = this.items[t];
    if (!s || s.disabled)
      return;
    const n = this.getListItem(t), o = this.isSelected(n);
    this.selectionType !== "trigger-only" && (this.selectionType === "single" ? this.selectedIndexes = o ? [] : [t] : this.toggleSelection(n) ? this._selectedIndexes.push(t) : this.removeFromSelectedIndexes(t)), this.focusIndex = t, this.dispatchEvent(
      new CustomEvent("selection", {
        detail: {
          index: t,
          selected: this.selectionType == "trigger-only" || !o,
          hasModifier: e
        },
        bubbles: !0,
        composed: !0
      })
    );
  }
  removeFromSelectedIndexes(t) {
    const e = this._selectedIndexes.indexOf(t);
    e !== -1 && this._selectedIndexes.splice(e, 1);
  }
  toggleSelection(t) {
    const e = !t.hasAttribute("selected");
    return this.setSelectedAttr(t, e), e;
  }
  setSelectedAttr(t, e) {
    t && (e ? t.setAttribute("selected", "") : t.removeAttribute("selected"), t.setAttribute("aria-selected", String(e)));
  }
  isSelected(t) {
    return t.hasAttribute("selected");
  }
};
i.ID = "sd-list", i.ensureDefined = () => {
  l.ensureDefined(), customElements.get(i.ID) || customElements.define(i.ID, i);
};
let r = i;
r.ensureDefined();
export {
  r as default
};
//# sourceMappingURL=list.mjs.map
